import { getAxiosData, postAxiosData } from './index.js'
import axios from 'axios'
/* 获取订单列表 */
export const getWaitPayOrderList = (data) => postAxiosData('/boschqrapi/crm-mall-api/getWaitPayOrderList',data).then( res => {
  return res;
})

/* 确认收到现金 */
export const confirmGetCash = (data) => postAxiosData('/boschqrapi/crm-mall-api/payTssCallbackOrder',data).then( res => {
  return res;
})

/* 去付款 */
export const goPayMoney = (data) => postAxiosData('/boschqrapi/integral/pay/h5Pay',data).then( res => {
  return res;
})

/* 获取跳转微信小程序的链接 */
export const sendTechnicianH5Url = (data) => postAxiosData('/boschqrapi/crm-mall-api/sendTechnicianH5Url',data).then( res => {
  return res;
})

/* 
* 获取企业微信授权链接 
* 
*/
export const getAuthorize = (data,authHttp) => axios.post(authHttp + '/securtary/wxCpAuthorize', data).then(res => {
  return res;
})

/* 
* 获取签名参数
*/
export const getJsapiSignature = (data,authHttp) => axios.post(authHttp + '/securtary/getJsapiTicket', data).then(res => {
  return res;
})